import { __spreadArrays } from "tslib";
import Vue from 'vue';
export default Vue.extend({
    props: {
        input: Object
    },
    data: function () {
        return {
            files: [],
        };
    },
    methods: {
        onFileSelected: function (e) {
            var filesToAdd = __spreadArrays(e.target.files);
            if (this.files.length + filesToAdd.length > 5) {
                e.preventDefault();
                e.target.value = null;
                this.files = [];
                alert('Only up to 5 files allowed!');
            }
            else {
                console.log('added', filesToAdd);
                this.files = filesToAdd;
            }
        }
    },
    computed: {
        filesList: function () {
            if (this.files.length > 0) {
                return this.files.length + " files selected (" + this.totalFileSize + " mb)";
            }
            return null;
        },
        totalFileSize: function () {
            return (this.files.reduce(function (acc, current) {
                return acc + current.size;
            }, 0) / 1000 / 1000).toFixed(3);
        }
    }
});
